module.exports = __webpack_public_path__ + "static/img/helping_hand_btn.89178143.png";